<script setup>
import { ref, watch } from "vue";

const emit = defineEmits(["confirm", "cancel"]);

const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: "Confirmation Required"
  },
  message: {
    type: String,
    default: null
  },
  largeWindow: {
    type: Boolean,
    default: false
  },
  okButton: {
    type: String,
    default: "OK"
  },
  cancelButton: {
    type: String,
    default: "Cancel"
  },
  hideCancelButton: {
    type: Boolean,
    default: false
  }
});

const showModal = ref(props.isVisible);

watch(
  () => props.isVisible,
  (newValue) => (showModal.value = newValue)
);

function _confirm() {
  emit("confirm");
  showModal.value = false;
}

function _cancel() {
  emit("cancel");
  showModal.value = false;
}
</script>

<template>
  <transition name="fade">
    <div
      class="confirm-modal"
      :class="{ large: largeWindow }"
      v-if="showModal"
    >
      <div :class="[largeWindow ? 'large-window' : 'window']">
        <div class="flex flex-col justify-between h-full">
          <h2
            class="text-2xl mb-4"
            v-html="title"
            v-if="title"
            :class="{ 'text-white': largeWindow }"
          ></h2>
          <div
            class="mb-8"
            v-html="message"
            v-if="message"
          ></div>

          <div class="flex flex-row justify-between items-center w-full flex-none">
            <div>
              <span
                ><button
                  v-if="!props.hideCancelButton"
                  class="btn bg-gray-200"
                  @click.prevent.stop="_cancel"
                >
                  {{ cancelButton }}
                </button></span
              >
            </div>
            <div>
              <span class="inline-block mr-4"><slot></slot></span>
              <button
                class="btn btn-primary"
                @click.prevent.stop="_confirm"
              >
                {{ okButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
